import { db, storage } from "../firebase_setup/firebase";
import { getCountFromServer,
        collection,
        deleteDoc,
        orderBy,
        getDocs,
        setDoc,
        getDoc,
        query,
        where,
        doc,
        updateDoc} from "firebase/firestore";
import { getDownloadURL,
        deleteObject,
        getMetadata,
        uploadBytes,
        ref } from "firebase/storage";
import { v4 as uuidv4 } from 'uuid';
// import { useFirestorePagination } from "../hooks/useFirestorePagination";


export const genUUID = () => {
    return uuidv4();
};



// Categories functions
export const getCategoriesList = async () => {
	try {
        let data = [];
        const resp = await getDocs(query(collection(db, "fraganceCategories"), orderBy('descripcion')));

        resp.forEach((doc) => {
            data.push({
                'uuid': doc.id,
                'descripcion': doc.data()['descripcion']
            });
        });

        return { message: "OK", data: data };
	} catch (error) {
		return { message: "ERROR", data: error };
	}
};

export const getCategory = async (pk) => {
    try {
        const docSnap = await getDoc(doc(db, "fraganceCategories", pk));

        if (docSnap.exists()) {
            return { message: "OK", data: { 'uuid': docSnap.id,
                                            'descripcion': docSnap.data()['descripcion'] } };
        } else {
            return { message: "ERROR", data: {} };
        }
    } catch (error) {
		return { message: "ERROR", data: error };
    }
};

export const setCategory = async (data) => {
    try {
        await setDoc(doc(db, "fraganceCategories", data?.uuid), {
            descripcion: data?.descripcion
        });

        return { message: "OK", data: {} };

    } catch (error) {
		return { message: "ERROR", data: error };
    }
};

export const delCategory = async (pk) => {
    try {
        await deleteDoc(doc(db, "fraganceCategories", pk));
        return { message: "OK", data: {} };
    } catch (error) {
		return { message: "ERROR", data: error };
    }
};



// Storage functions
const uploadAllImages = async (pk, imagesArray) => {
    let arrCurImgs = [];
    const actualArticle = await getArticle(pk);

    if (actualArticle?.message?.toUpperCase() === 'OK') {
        arrCurImgs = actualArticle?.data?.images;
    };

    arrCurImgs.map(async (el) => {
        const elm = imagesArray.filter((i) => i.url === el.url);
        if (elm.length === 0) {
            try {
                await deleteObject(ref(storage, el.url));
            } catch (error) {
                console.error("Error al eliminar:", error.message);
            };
        };
    });

    const uploadPromises = imagesArray.map(async (img) => {
        if (img.file) {
            const storageRef = ref(storage, `images/${img.file.name}`);
            await uploadBytes(storageRef, img.file);
            return getDownloadURL(storageRef);
        } else {
            return img.url;
        };
    });

    const urls = await Promise.all(uploadPromises);
    return urls;
};

const getImageInfo = async (arr) => {
    try {
        if(Array.isArray(arr))
        {
            const getInfo = arr.map(async (el) => {
            return { 'url': el,
                     'type': (await getMetadata(ref(storage, el))).contentType };
            });
            const data = await Promise.all(getInfo);
            return data;
        }else{
            const data = [{ 'url': arr , 'type': "image/jpeg" }];
            return data;
        }

    } catch (err) {
        console.error('Se presento un error al procesar los metadatos de las imagenes del artículo. Error :>> ', err);
        return [];
    }
};



// Articles functions
export const getProductPublicList = async (querydata) => {
    try {
        //llamada de hook

        let data = [];

        querydata?.forEach((doc) => {
            let img = [];
            if(Array.isArray(doc?.data()['images']))
            {
                doc?.data()['images'].forEach((ig) => {
                    img.push({'url': ig});
                });
            }else{
                img.push({'url': doc?.data()['images']})
            }

            data.push({
                'uuid': doc.id,
                'descripcion_corta': doc.data()['descripcion_corta'],
                'linea': doc.data()['linea'],
                'marca': doc.data()['marca'],
                'sku': doc.data()['sku'],
                'precio_dept': doc.data()['precio_dept'],
                'descuento': doc.data()['descuento'],
                'existencias': doc.data()['existencias'],
                'images': img,
            });
        });

        return { message: "OK", data: data };
	} catch (error) {
		return { message: "ERROR", data: error };
	}
};

export const getPublicProductItem = async (pk) => {
    try {
        let data = [];
        const docSnap = await getDoc(doc(db, "fragances", pk));

        if (docSnap.exists()) {
            data.push({
                'uuid': docSnap.id,
                'referencia': docSnap.data()['referencia'],
                'sku': docSnap.data()['sku'],
                'descripcion_corta': docSnap.data()['descripcion_corta'],
                'descripcion_larga': docSnap.data()['descripcion_larga'],
                'linea': docSnap.data()['linea'],
                'marca': docSnap.data()['marca'],
                'precio_dept': docSnap.data()['precio_dept'],
                'descuento': docSnap.data()['descuento'],
                'existencias': docSnap.data()['existencias'],
                'images': await getImageInfo(docSnap.data()['images'])
            });

            return { message: "OK", data: data };
        } else {
            return { message: "ERROR", data: {} };
        }
    } catch (error) {
		return { message: "ERROR", data: error };
    }
};

export const getProductAdminList = async (querydata) => {
    try {
        let data = [];

        querydata.forEach((doc) => {
            let img = [];
            if(Array.isArray(doc?.data()['images']))
            {
                doc?.data()['images'].forEach((ig) => {
                    img.push({'url': ig});
                });
            }else{
                img.push({'url': doc?.data()['images']})
            }

            data.push({
                'uuid': doc.id,
                'referencia': doc.data()['referencia'],
                'sku': doc.data()['sku'],
                'descripcion_corta': doc.data()['descripcion_corta'],
                'descripcion_larga': doc.data()['descripcion_larga'],
                'precio_dept': doc.data()['precio_dept'],
                'descuento': doc.data()['descuento'],
                'existencias': doc.data()['existencias'],
                'vendidos': doc.data()['vendidos'],
                'images': img,
            });
        });

        return { message: "OK", data: data };
	} catch (error) {
		return { message: "ERROR", data: error };
	}
};

export const getAdminProductItem = async (pk) => {
    try {
        let data = [];
        const docSnap = await getDoc(doc(db, "fragances", pk));

        if (docSnap.exists()) {
            data.push({
                'uuid': docSnap.id,
                'referencia': docSnap.data()['referencia'],
                'sku': docSnap.data()['sku'],
                'descripcion_corta': docSnap.data()['descripcion_corta'],
                'descripcion_larga': docSnap.data()['descripcion_larga'],
                'linea': docSnap.data()['linea'],
                'marca': docSnap.data()['marca'],
                'precio_dept': docSnap.data()['precio_dept'],
                'descuento': docSnap.data()['descuento'],
                'existencias': docSnap.data()['existencias'],
                'vendidos': docSnap.data()['vendidos'],
                'images': await getImageInfo(docSnap.data()['images'])
            });

            return { message: "OK", data: data };
        } else {
            return { message: "ERROR", data: {} };
        }
    } catch (error) {
		return { message: "ERROR", data: error };
    }
};

export const getArticleList = async (querydata) => {
    try {
        let data = [];

        querydata.forEach((doc) => {
            data.push({
                'uuid': doc.id,
                'descripcion_corta': doc.data()['descripcion_corta'],
                'referencia': doc.data()['referencia'],
                'sku': doc.data()['sku'],
                'descuento': doc.data()['descuento'] || "0",
            });
        });

        return { message: "OK", data: data };
	} catch (error) {
		return { message: "ERROR", data: error };
	}
};

export const getArticle = async (pk) => {
    try {
        const docSnap = await getDoc(doc(db, "fragances", pk));

        if (docSnap.exists()) {
            const data = {  'uuid': docSnap.id,
                            'referencia': docSnap.data()['referencia'],
                            'sku': docSnap.data()['sku'],
                            'descripcion_corta': docSnap.data()['descripcion_corta'],
                            'descripcion_larga': docSnap.data()['descripcion_larga'],
                            'linea': docSnap.data()['linea'],
                            'marca': docSnap.data()['marca'],
                            'precio_dept': docSnap.data()['precio_dept'],
                            'descuento': docSnap.data()['descuento'],
                            'existencias': docSnap.data()['existencias'],
                            'vendidos': docSnap.data()['vendidos'],
                            'images': await getImageInfo(docSnap.data()['images'])
                        };

            return { message: "OK", data: data };
        } else {
            return { message: "ERROR", data: {} };
        }
    } catch (error) {
		return { message: "ERROR", data: error };
    }
};

export const setArticle = async (data) => {
    try {
        await setDoc(doc(db, "fragances", data?.uuid), {
            referencia: data?.referencia,
            sku: data?.sku,
            descripcion_corta: data?.descripcion_corta,
            descripcion_larga: data?.descripcion_larga,
            linea: data?.linea,
            marca: data?.marca,
            precio_dept: String(data?.precio_dept),
            descuento: String(data?.descuento),
            existencias: data?.existencias,
            vendidos: data?.vendidos,
            images: []
        }, { merge: true });

        let imgUrls = [];
        if (data?.images && data?.images.length > 0) {
            try {
                imgUrls = await uploadAllImages(data?.uuid, data?.images);
            } catch (err) {
                return { message: "ERROR", data: err };
            }
        }

        if (imgUrls.length > 0){
            await setDoc(doc(db, "fragances", data?.uuid), {
                images: imgUrls
            }, { merge: true });
        }

        return { message: "OK", data: {} };
    } catch (error) {
		return { message: "ERROR", data: error };
    }
};

export const updateArticle = async (data) => {
    try {
        await updateDoc(doc(db, "fragances", data?.uuid), {
            referencia: data?.referencia,
            sku: data?.sku,
            descripcion_corta: data?.descripcion_corta,
            descripcion_larga: data?.descripcion_larga,
            linea: data?.linea,
            marca: data?.marca,
            precio_dept: String(data?.precio_dept),
            descuento: String(data?.descuento),
            existencias: data?.existencias,
            vendidos: data?.vendidos,
            images: []
        });

        let imgUrls = [];
        if (data?.images && data?.images.length > 0) {
            try {
                imgUrls = await uploadAllImages(data?.uuid, data?.images);
            } catch (err) {
                return { message: "ERROR", data: err };
            }
        }

        if (imgUrls.length > 0){
            await setDoc(doc(db, "fragances", data?.uuid), {
                images: imgUrls
            }, { merge: true });
        }

        return { message: "OK", data: {} };
    } catch (error) {
		return { message: "ERROR", data: error };
    }
};

export const delArticle = async (pk) => {
    try {
        const docSnap = await getDoc(doc(db, "fragances", pk));

        if (docSnap.exists()) {
            try {
                if (docSnap.data()['images'].length > 0) {
                    docSnap.data()['images'].map(async (el) => {
                        try {
                            await deleteObject(ref(storage, el));
                        } catch (error) {
                            console.error("Error al eliminar:", error.message);
                        };
                    });
                };
            } catch {}

            await deleteDoc(doc(db, "fragances", pk));
            return { message: "OK", data: {} };
        } else {
            return { message: "ERROR", data: 'Artículo no identificado.' };
        }
    } catch (error) {
		return { message: "ERROR", data: error };
    }
};

export const getTotalArticles = async () => {
    let totalProducts = 0;
    let totalInvestment = 0;

    try {
        const products = await getCountFromServer(query(collection(db, "articles"), where("estatus", "!=", "vendido")));
        totalProducts = products.data().count;
    } catch (err) {
        console.error('Error en recuperación del total de bienes :>>', err);
    }

    try {
        const investment = await getDocs(query(collection(db, 'articles'), where('estatus', '!=', "vendido")));
        investment.forEach((doc) => {
            totalInvestment += (parseFloat(doc.data()['piezas']) || 1) * (parseFloat(doc.data()['costo_adquisicion']) || 0);
        });
    } catch (err) {
        console.error('Error en recuperación del total de inversión :>>', err);
    }

    return { message: "OK", data: { 'totalProducts': totalProducts,
                                    'totalInvestment': totalInvestment } };
};
